/** Корень React-приложения: его id равен projectName. */
export function getRoot(rootId: string): Element | null {
  return document.getElementById(rootId);
}

/** Читаемый селектор элемента. Приоритет — по стабильности, хешированные классы последними. */
export function getSelector(node: Node | null | undefined): string {
  if (!node || node.nodeType !== Node.ELEMENT_NODE) {
    return '(нет узла)';
  }

  const element = node as Element;
  const tag = element.tagName.toLowerCase();

  if (element.id) {
    return `${tag}#${element.id}`;
  }

  const dataName = element.getAttribute('data-name') || element.getAttribute('data-testid');

  if (dataName) {
    return `${tag}[${dataName}]`;
  }

  const classes = (element.getAttribute('class') || '').split(/\s+/).filter(Boolean).slice(0, 2);

  return classes.length ? `${tag}.${classes.join('.')}` : tag;
}
